import React, { useReducer } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import GridInputRow from "../../componentes/form-grids/GridInputRow";
import { Grid } from "@material-ui/core";
import InputField from "../../componentes/form-fields/InputField/InputField";
import CustomAlert from "../../componentes/alerts/CustomAlert";
import GridItemContainer from "../../componentes/form-grids/GridItemContainer";
import changePasswordService from "./changePasswordService";
import { useHistory } from "react-router";
import { DefaultScreenAccordion } from "../../componentes/layouts/components/DefaultScreenAccordion";
import SearchClearSaveRow from "../../componentes/button/SearchClearSaveRow";

export default function ChangePassword() {
    const { t } = useTranslation();
    const { control } = useForm();
    const history = useHistory();
    const userId = sessionStorage.getItem("userId");
    const status = sessionStorage.getItem("status");

    function reducer(state, action) {
        switch (action.type) {
            case 'update':
                return { ...state, ...action.data }
            case "clear":
                return initialPasswordState
            case 'success':
                return { ...state, success: true, error: false }
            case 'error':
                return { ...state, success: false, error: true }
            case 'close_alert':
                return { ...state, success: false, error: false }
            default:
                return new Error();
        }
    }

    const initialPasswordState = {
        id: userId,
        currentPassword: "",
        newPassword: "",
        confirmNewPassword: "",
        loggedUserId: userId,
        status: status,
        alertMessage: "",
        success: false,
        error: false,
    };

    const [password, dispatch] = useReducer(reducer, initialPasswordState);
    const { currentPassword, newPassword, confirmNewPassword, alertMessage, success, error } = password

    const handleChange = ({ target: { name, value } }) => {
        dispatch({
            type: 'update',
            data: { [name]: value }
        })
    };

    const samePasswords = () =>
        password.newPassword === password.confirmNewPassword;

    const sameCurrentPassword = () =>
        password.newPassword !== password.currentPassword && password.confirmNewPassword !== password.currentPassword;

    const canSave = () =>
        password.currentPassword &&
        password.newPassword &&
        password.confirmNewPassword !== 0;

    const savePassword = () => {
        if (canSave()) {
            if (samePasswords) {
                if (sameCurrentPassword()) {
                    const {confirmNewPassword, alertMessage, success, error, status, ...data} = password;
                    changePasswordService
                        .update(data)
                        .then((response) => {
                            if (response.status === 200) {
                                dispatch({
                                    type: 'update',
                                    data: {alertMessage: "", success: response.data.id > 0, error: !(response.data.id > 0)}
                                })
                                history.push('/login');
                            } else {
                                dispatch({
                                    type: 'error',
                                })
                            }
                        })
                        .catch((e) => {
                            dispatch({
                                type: 'error',
                            })
                            console.log(e)
                        });
                } else {
                    dispatch({
                        type: 'update',
                        data: {alertMessage: t("currentPasswords"), error: true, success: false}
                    })
                }
            } else {
                dispatch({
                    type: 'update',
                    data: { alertMessage: t("differentPasswords"), error: true, success: false }
                })
            }
        } else {
            dispatch({
                type: 'update',
                data: { alertMessage: t("checkFields"), error: true, success: false }
            })
        }
    };

    return (
        <DefaultScreenAccordion
            title={"changePassword"}
            isRegister
            fields={
                <GridItemContainer>
                    <CustomAlert
                        success={success}
                        error={error}
                        message={alertMessage}
                        handleCloseAlert={() => dispatch({ type: 'close_alert' })}
                    />
                    <GridInputRow>
                        <Grid item xs={12} sm={6} md={3}>
                            <InputField
                                name="currentPassword"
                                control={control}
                                defaultValue=""
                                onChange={handleChange}
                                value={currentPassword}
                                length={50}
                                type="password"
                                error={error && currentPassword === ""}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <InputField
                                name="newPassword"
                                control={control}
                                defaultValue=""
                                onChange={handleChange}
                                value={newPassword}
                                length={50}
                                type="password"
                                error={error && newPassword === ""}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <InputField
                                name="confirmNewPassword"
                                control={control}
                                defaultValue=""
                                onChange={handleChange}
                                value={confirmNewPassword}
                                length={50}
                                type="password"
                                error={
                                    error &&
                                    (alertMessage === t("differentPasswords") ||
                                        confirmNewPassword === "")
                                }
                            />
                        </Grid>
                    </GridInputRow>
                    <SearchClearSaveRow
                        onClickSave={savePassword}
                        onClickClear={() => dispatch({ type: 'clear' })}
                    />
                </GridItemContainer>
            } />
    );
};
